const productRecommendationsSection = document.querySelector("section.recommendations");

const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
        .then(response => response.text())
        .then(text => {
            const html = document.createElement('div'); 
            html.innerHTML = text;
            const recommendations = html.querySelector('.recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
                productRecommendationsSection.innerHTML = recommendations.innerHTML;
                
                // Count the recommendation items
                const recommendationItems = productRecommendationsSection.querySelectorAll('.item-row__list--item');
                if (logs) { console.log(`Number of recommendation items loaded: ${recommendationItems.length}`); }

                
                // Dispatch custom event
                document.dispatchEvent(new CustomEvent('recommendationsLoaded'));
            }
            if (logs) { console.log('Recommendations loaded'); }
        })
        .catch(e => {
            console.error(e);
        });
};

const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

observer.observe(productRecommendationsSection);

window.addEventListener("resize", () => {
    observer.observe(productRecommendationsSection);
});
